import { useContext } from "react";
import { AuthContext } from "common/providers/AuthProvider";

export const useAuth = () => useContext(AuthContext);

export default useAuth;
